import type {StyleRef} from '@wix/document-services-types'
import type {StyleProps} from '../types'

const DESIGN_PARTS = ['item', 'sub-item']

const DEFAULT_VALUES = {
    color: 'rgba(var(--color_15),1)',
    'text-transform': 'none',
    'text-highlight': 'rgba(0, 0, 0, 0)',
    'letter-spacing': 'normal',
    'line-height': 'normal'
}

const stylePropsToMigrate = Object.keys(DEFAULT_VALUES)

const convertRevertedStyleProps = (styleProps: StyleProps) => {
    DESIGN_PARTS.forEach(type => {
        stylePropsToMigrate.forEach(prop => {
            const fullPropName = `${type}-${prop}`
            if (styleProps[fullPropName] === 'revert') {
                styleProps[fullPropName] = DEFAULT_VALUES[prop]
            }
        })
    })

    return styleProps
}

export const migrateStructuredMegaMenuSubmenuDesign = (styleItems: StyleRef[]) => {
    styleItems.forEach(styleItem => {
        convertRevertedStyleProps(styleItem.style.properties)
    })
}
